/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import RotateRightIcon from "@mui/icons-material/RotateRight";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import ClearIcon from "@mui/icons-material/Clear";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import {
  SET_REPORT,
  SET_REPORT_OBSERVATION_PHOTO,
  SET_REPORT_OBSERVATION_TEST_PHOTO,
  SHOW_MODAL_CONFIRM,
} from "../../../../store/actions";
import { fileChangedHandler } from "../../../shared/helpers";
export const ROTATE = "$rotate$"; //do not change

export default function ImageEditor(props) {
  const {
    src = "",
    reduxKey,
    rotation = 0,
    imgRotationKey,
    disableRotate = false,
  } = props || {};
  const [link] = (src || "").split(ROTATE);
  const [scale, setScale] = useState(1);
  const [rotatedScale, setRotatedScale] = useState(0);
  const [localAngle, setLocalAngle] = useState(rotation ?? 0);
  const [fileError, setFileError] = useState("");

  const imgRef = useRef(null);
  const inputRef = useRef(null);

  const dispatch = useDispatch();
  const ucp = (path, text) => {
    dispatch({
      type: SET_REPORT,
      payload: { path, data: text },
    });
  };

  const setRotation = (angle) => {
    setLocalAngle(angle);
    dispatch({
      type: SET_REPORT,
      payload: { path: imgRotationKey, data: angle },
    });
  };

  useLayoutEffect(() => {
    setLocalAngle(rotation);
  }, [rotation]);

  useLayoutEffect(() => {
    if (
      rotation === 90 ||
      rotation === -90 ||
      rotation === 270 ||
      rotation === -270
    ) {
      setScale(rotatedScale);
    } else {
      setScale(1);
    }
  }, [rotation, rotatedScale]);

  useLayoutEffect(() => {
    if (imgRef.current) {
      setRotatedScale(imgRef.current.offsetHeight / imgRef.current.offsetWidth);
    }
  }, [imgRef]);

  return (
    <div className="d-flex justify-content-center report-img">
      <div className="image-editor">
        {src && !disableRotate && (
          <div className="rotate-btns">
            <RotateLeftIcon
              onClick={() => setRotation(rotation === -270 ? 0 : rotation - 90)}
            />
            <span className="vl"></span>
            <RotateRightIcon
              onClick={() => setRotation(rotation === 270 ? 0 : rotation + 90)}
            />
          </div>
        )}
        {link ? (
          <img
            ref={imgRef}
            {...props}
            src={link}
            style={{
              transform: `rotate(${localAngle}deg) scale(${scale})`,
              transition: "all 0.4s ease 0s",
            }}
          />
        ) : (
          <div className="d-flex flex-column align-items-center">
            <CloudUploadIcon
              color="gray"
              className="cursor-pointer"
              onClick={() => {
                inputRef.current?.click();
              }}
              sx={{ fontSize: "3rem !important", color: "gray" }}
            />
            {fileError && <div>{fileError}</div>}
            <input
              ref={inputRef}
              type="file"
              accept="image/jpeg,image/png"
              onChange={(e) =>
                fileChangedHandler(
                  e,
                  setFileError,
                  (url) => ucp(reduxKey, url),
                  setRotation
                )
              }
              style={{ display: "none" }}
            />
          </div>
        )}
        {link && (
          <div className="image-editor-tools">
            <ClearIcon
              style={{
                fontSize: "1rem",
                color: "#b44a4a",
                filter: "drop-shadow(0 0 0 rgba(0, 0, 0, 0.5))",
              }}
              onClick={() => {
                dispatch({
                  type: SHOW_MODAL_CONFIRM,
                  payload: {
                    showConfirm: true,
                    onDelete: () => ucp(reduxKey, ""),
                  },
                });
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export function ObservationPhotoEditor(props) {
  const { src = "", oi, pi, ri, ti, ii, rotation = 0, photos } = props || {};
  const [link] = (src || "").split(ROTATE);
  const [scale, setScale] = useState(1);
  const [rotatedScale, setRotatedScale] = useState(0);
  const [fileError, setFileError] = useState("");
  const [localAngle, setLocalAngle] = useState(rotation ?? 0);
  const imgRef = useRef(null);
  const inputRef = useRef(null);

  const dispatch = useDispatch();
  const ucp = (text) => {
    if (pi !== undefined) {
      dispatch({
        type: SET_REPORT_OBSERVATION_PHOTO,
        payload: {
          path: "url",
          data: text,
          observationIndex: oi,
          photoIndex: pi,
          roomIndex: ri,
        },
      });
      dispatch({
        type: SET_REPORT_OBSERVATION_PHOTO,
        payload: {
          path: "rotation",
          data: rotation,
          observationIndex: oi,
          photoIndex: pi,
          roomIndex: ri,
        },
      });
    } else if (ti !== undefined) {
      dispatch({
        type: SET_REPORT_OBSERVATION_TEST_PHOTO,
        payload: {
          path: "url",
          data: text,
          observationIndex: oi,
          testIndex: ti,
          roomIndex: ri,
          imageIndex: ii,
        },
      });
      dispatch({
        type: SET_REPORT_OBSERVATION_TEST_PHOTO,
        payload: {
          path: "rotation",
          data: rotation,
          observationIndex: oi,
          testIndex: ti,
          roomIndex: ri,
          imageIndex: ii,
        },
      });
    }
  };

  const setRotation = (angle) => {
    if (pi !== undefined) {
      dispatch({
        type: SET_REPORT_OBSERVATION_PHOTO,
        payload: {
          path: "rotation",
          data: angle,
          observationIndex: oi,
          photoIndex: pi,
          roomIndex: ri,
        },
      });
    } else if (ti !== undefined) {
      dispatch({
        type: SET_REPORT_OBSERVATION_TEST_PHOTO,
        payload: {
          path: "rotation",
          data: angle,
          observationIndex: oi,
          testIndex: ti,
          roomIndex: ri,
          imageIndex: ii,
        },
      });
    }
    setLocalAngle(angle);
  };

  useEffect(() => {
    if (!imgRef.current) return;

    const isSideways =
      rotation === 90 ||
      rotation === -90 ||
      rotation === 270 ||
      rotation === -270;

    const desiredScale = isSideways ? rotatedScale : 1;

    // Avoid unnecessary state updates
    setScale((prev) => (prev !== desiredScale ? desiredScale : prev));
  }, [rotation, rotatedScale]);

  useLayoutEffect(() => {
    setLocalAngle(rotation);
  }, [rotation]);

  useLayoutEffect(() => {
    if (imgRef.current) {
      const height = imgRef.current.offsetHeight;
      const width = imgRef.current.offsetWidth;
      if (height < width) {
        setRotatedScale(height / width);
      } else {
        setRotatedScale(width / height);
      }
    }
  }, [imgRef, link]);

  const handleImageClick = () => {
    if (photos && photos.length > 0) {
      const viewerUrl = `/photo-viewer?photos=${encodeURIComponent(
        JSON.stringify(photos)
      )}&photo=${ii ?? 0}`;
      window.open(viewerUrl, "_blank");
    }
  };

  return (
    <div className="d-flex report-img" style={{ padding: "0 0.5cm" }}>
      <div className="image-editor">
        {link && (
          <div className="obs-photo-rotate-btns" style={{ zIndex: 1000 }}>
            <RotateLeftIcon
              onClick={() => setRotation(rotation === -270 ? 0 : rotation - 90)}
            />
            <span className="vl"></span>
            <RotateRightIcon
              onClick={() => setRotation(rotation === 270 ? 0 : rotation + 90)}
            />
          </div>
        )}
        {link ? (
          <img
            ref={imgRef}
            {...props}
            src={link}
            onClick={photos ? handleImageClick : undefined}
            style={{
              transform: `rotate(${localAngle}deg) scale(${scale})`,
              transition: "all 0.4s ease 0s",
              cursor: photos ? "pointer" : "default",
            }}
          />
        ) : (
          <div className="upload-new-img">
            <CloudUploadIcon
              color="gray"
              className="cursor-pointer"
              onClick={() => {
                inputRef.current?.click();
              }}
            />
            {fileError && <div>{fileError}</div>}
            <input
              ref={inputRef}
              type="file"
              accept="image/jpeg,image/png"
              onChange={(e) =>
                fileChangedHandler(e, setFileError, ucp, setRotation)
              }
              style={{ display: "none" }}
            />
          </div>
        )}
        {link && (
          <div className="image-editor-tools">
            <ClearIcon
              style={{
                fontSize: "1rem",
                color: "#b44a4a",
                filter: "drop-shadow(0 0 0 rgba(0, 0, 0, 0.5))",
              }}
              onClick={() => {
                dispatch({
                  type: SHOW_MODAL_CONFIRM,
                  payload: {
                    showConfirm: true,
                    onDelete: () => ucp(""),
                  },
                });
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export function ObservationPhotoEditorImages(props) {
  const { src = "", oi, pi, ri, ti, ii, rotation = 0 } = props || {};
  const [link] = (src || "").split(ROTATE);
  const [scale, setScale] = useState(1);
  const [rotatedScale, setRotatedScale] = useState(1);
  const [fileError, setFileError] = useState("");
  const [localAngle, setLocalAngle] = useState(rotation ?? 0);

  const imgRef = useRef(null);
  const inputRef = useRef(null);

  const dispatch = useDispatch();
  const ucp = (text) => {
    if (pi !== undefined) {
      dispatch({
        type: SET_REPORT_OBSERVATION_PHOTO,
        payload: {
          path: "url",
          data: text,
          observationIndex: oi,
          photoIndex: pi,
          roomIndex: ri,
        },
      });
      dispatch({
        type: SET_REPORT_OBSERVATION_PHOTO,
        payload: {
          path: "rotation",
          data: rotation,
          observationIndex: oi,
          photoIndex: pi,
          roomIndex: ri,
        },
      });
    } else if (ti !== undefined) {
      dispatch({
        type: SET_REPORT_OBSERVATION_TEST_PHOTO,
        payload: {
          path: "url",
          data: text,
          observationIndex: oi,
          testIndex: ti,
          roomIndex: ri,
          imageIndex: ii,
        },
      });
      dispatch({
        type: SET_REPORT_OBSERVATION_TEST_PHOTO,
        payload: {
          path: "rotation",
          data: rotation,
          observationIndex: oi,
          testIndex: ti,
          roomIndex: ri,
          imageIndex: ii,
        },
      });
    }
  };

  const setRotation = (angle) => {
    if (pi !== undefined) {
      dispatch({
        type: SET_REPORT_OBSERVATION_PHOTO,
        payload: {
          path: "rotation",
          data: angle,
          observationIndex: oi,
          photoIndex: pi,
          roomIndex: ri,
        },
      });
    } else if (ti !== undefined) {
      dispatch({
        type: SET_REPORT_OBSERVATION_TEST_PHOTO,
        payload: {
          path: "rotation",
          data: angle,
          observationIndex: oi,
          testIndex: ti,
          roomIndex: ri,
          imageIndex: ii,
        },
      });
    }
    setLocalAngle(angle);
  };

  useLayoutEffect(() => {
    if (imgRef.current) {
      const { naturalHeight: h, naturalWidth: w } = imgRef.current;

      const isRotated = [90, -90, 270, -270].includes(rotation);

      if (isRotated) {
        const ratio = h / w < 1 ? h / w : w / h;
        setRotatedScale(ratio);
        setScale(0.8);
      } else {
        setScale(1);
        setRotatedScale(1);
      }
    }
  }, [rotation]);

  useLayoutEffect(() => {
    setLocalAngle(rotation);
  }, [rotation]);

  const handleImageClick = (photoIndex) => {
    const viewerUrl = `/photo-viewer?photos=${encodeURIComponent(
      JSON.stringify(props.photos)
    )}&photo=${photoIndex}&title=${props.title}`;
    window.open(viewerUrl, "_blank");
  };

  const isRotated = [90, -90, 270, -270].includes(rotation);

  return (
    <div className="d-flex report-img" style={{ padding: "0 0.5cm" }}>
      <div className="image-editor">
        {link && (
          <div className="obs-photo-rotate-btns">
            <RotateLeftIcon
              onClick={() => setRotation(rotation === -270 ? 0 : rotation - 90)}
            />
            <span className="vl"></span>
            <RotateRightIcon
              onClick={() => setRotation(rotation === 270 ? 0 : rotation + 90)}
            />
          </div>
        )}
        {link ? (
          <div
            style={{
              width: "300px",
              height: "250px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "hidden",
              position: "relative",
            }}
          >
            <img
              onClick={() => handleImageClick(props.pi)}
              ref={imgRef}
              {...props}
              src={link}
              style={{
                transform: `rotate(${localAngle}deg) scale(${
                  isRotated ? "0.8" : scale
                })`,
                transition: "all 0.4s ease 0s",
                width: "100%",
                height: "100%",
                maxHeight: "250px",
                maxWidth: "300px",
                objectFit: "contain",
                display: "block",
                margin: "0 auto",
                position: "absolute",
                transformOrigin: "center center",
              }}
            />
          </div>
        ) : (
          <div className="upload-new-img-obs">
            <CloudUploadIcon
              color="gray"
              className="cursor-pointer"
              style={{ fontSize: "2.5rem" }}
              onClick={() => {
                inputRef.current?.click();
              }}
            />
            {fileError && <div>{fileError}</div>}
            <input
              ref={inputRef}
              type="file"
              accept="image/jpeg,image/png"
              onChange={(e) =>
                fileChangedHandler(e, setFileError, ucp, setRotation)
              }
              style={{ display: "none" }}
            />
          </div>
        )}
        {link && (
          <div className="image-editor-tools" style={{ right: "-32px" }}>
            <ClearIcon
              style={{
                fontSize: "1.6rem",
                color: "#b44a4a",
                filter: "drop-shadow(0 0 0 rgba(0, 0, 0, 0.5))",
              }}
              onClick={() => {
                dispatch({
                  type: SHOW_MODAL_CONFIRM,
                  payload: {
                    showConfirm: true,
                    onDelete: () => ucp(""),
                  },
                });
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
}
